import type { IndicacaoAmigo } from "../../../services/indicacoesAmigos"

export enum IndicacoesAmigosActionsTypes {
    CARREGAR = "CARREGAR",
}

export type IndicacoesAmigosActions = {
    type: IndicacoesAmigosActionsTypes.CARREGAR
    payload: IndicacaoAmigo[]
}
